import classNames from 'classnames'
import React, { PropsWithChildren, useCallback } from 'react'
import SortAscIcon from '../../assets/icons/sort-asc.svg'
import SortDescIcon from '../../assets/icons/sort-desc.svg'

export type DesktopColumnHeaderProps = {
  arrowPositionClassName?: string
  arrowSizeClassName?: string
  ascending: boolean
  className?: string
  enableSort?: boolean
  isCurrentSortColumn?: boolean
  onSort?: (asc: boolean) => void
  staticWidthClass?: string
}

export const DesktopColumnHeader = ({
  arrowPositionClassName = 'bottom-0',
  arrowSizeClassName = 'w-10 h-10 md:w-15 md:h-15 xl:w-20 xl:h-20',
  ascending,
  children,
  className,
  enableSort = true,
  isCurrentSortColumn = false,
  onSort: onSortProps,
  staticWidthClass,
}: PropsWithChildren<DesktopColumnHeaderProps>) => {
  const onSort = useCallback(() => {
    if (enableSort) {
      onSortProps?.(!ascending)
    }
  }, [ascending, enableSort, onSortProps])

  const Icon = ascending ? SortAscIcon : SortDescIcon

  return (
    <span
      className={
        className ??
        classNames(
          {
            'flex-none': staticWidthClass,
            'flex-1': !staticWidthClass,
          },
          staticWidthClass,
          'flex items-center relative text-secondary-dark mr-15 last:mr-0',
          {
            'cursor-pointer': enableSort,
          },
          'font-t text-t-300',
          'md:text-t-500',
          'xl:text-t-700'
        )
      }
      onClick={onSort}
    >
      {enableSort && (
        <Icon
          className={classNames(
            'inline-block flex-none mr-10 fill-current',
            arrowSizeClassName,
            arrowPositionClassName,
            {
              'text-primary': isCurrentSortColumn,
            }
          )}
          width={45}
          height={45}
        />
      )}

      <span>{children}</span>
    </span>
  )
}
